import { render, staticRenderFns } from "./inspectionPointQrCode.vue?vue&type=template&id=8f676910&scoped=true"
import script from "./inspectionPointQrCode.vue?vue&type=script&lang=js"
export * from "./inspectionPointQrCode.vue?vue&type=script&lang=js"
import style0 from "./inspectionPointQrCode.vue?vue&type=style&index=0&id=8f676910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f676910",
  null
  
)

export default component.exports